import { Calendar, Dumbbell, Target, Flame } from 'lucide-react';
import { getDifficultyLabel } from '../../utils/constants';

const goalLabels = {
  weight_loss: 'Weight Loss', muscle_building: 'Muscle Building', endurance: 'Endurance',
  general_fitness: 'General Fitness', ultimate_fitness: 'Ultimate Fitness',
  strength: 'Strength', core_strength: 'Core Strength',
};

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-3">
      <Icon className="h-5 w-5 text-primary" />
      <span className="text-muted-foreground">{label}</span>
    </div>
    <span className="text-white font-heading capitalize">{value}</span>
  </div>
);

export const ProgramStatsCard = ({ program }) => {
  const totalWorkouts = program.weeks?.reduce((acc, w) => acc + (w.workouts?.length || 0), 0) || 0;
  return (
    <div className="bg-card border border-border p-6" data-testid="program-stats-card">
      <h3 className="font-heading text-xl text-white uppercase tracking-wider mb-4">Program Stats</h3>
      <div className="space-y-4">
        <Row icon={Calendar} label="Duration" value={`${program.duration_weeks} Weeks`} />
        <Row icon={Dumbbell} label="Total Workouts" value={totalWorkouts} />
        <Row icon={Target} label="Goal" value={goalLabels[program.goal] || program.goal} />
        <Row icon={Flame} label="Difficulty" value={getDifficultyLabel(program.difficulty)} />
      </div>
    </div>
  );
};
